import {
  START_SPINNER,
  STOP_SPINNER
} from './mutations-types'
export default {
  startSpinner ({commit}) {
    commit(START_SPINNER)
  },
  stopSpinner ({commit}) {
    commit(STOP_SPINNER)
  }
}
